import { GET } from "../../Shared/helper/constants";
import { throwError } from "../../Shared/interceptor/apiError";
import api from "../../Shared/interceptor/apiOrp";
import { BFE_BASE_URL, CONFIG_KEY, ENDPOINTS, ORP_BASE_URL, POST, SUCCESS_CODE } from "../GlobalConstant";

export const getProductConfigData = async (productCode) => {
    try {
        const configData = await api.request({
            method: GET,
            headers: { product: productCode ?? CONFIG_KEY?.AWCONFIG },
            url: `${ORP_BASE_URL}${ENDPOINTS.PRODUCT_CONFIG_API}`,

        });
        if (configData?.data?.statusCode === SUCCESS_CODE) {
            return configData?.data?.result?.configData
        } else {
            throw new Error()
        }
    } catch (e) {
        throw new Error(e)
    }
}


export const getLangData = async (headers = {}) => {
    try {
        const langConfigData = await api.request({
            method: GET,
            headers: { ...headers, product: CONFIG_KEY.UI_TRANSALTION },
            url: `${ORP_BASE_URL}${ENDPOINTS.TRANSLATION_API_URL}`,

        });
        if (langConfigData?.data?.statusCode === SUCCESS_CODE) {
            return langConfigData?.data?.result?.configData
            
        } else {
            throw new Error()
        }
    } catch (e) {
        throw new Error(e)
    }
}

export const getBundleData = async (req, API_VERSION = "v1") => {
    try {
        const response = await api.request({
            method: POST,
            data: req,
            url: (`${BFE_BASE_URL}${ORP_BASE_URL}${ENDPOINTS.BUNDLE_API_URL}`).replace("API_VERSION", API_VERSION),

        });
        if (response?.data?.statusCode === SUCCESS_CODE) {
            return response?.data?.result;
        } else {
            throwError(response?.data, response?.data?.message)
        }
    } catch (e) {
        throwError(e)
    }
}